import type { TextbookRequestStatus } from '@/api/textbookRequests'

export const TEXTBOOK_STATUS_LABELS: Record<TextbookRequestStatus, string> = {
  REQUESTED_TO_HQ: '요청됨',
  OUTBOUND_REQUESTING: '출고 요청 중',
  OUTBOUND_REQUESTED: '출고 요청 완료',
  OUTBOUND_UNCERTAIN: '접수 확인 필요',
  SHIPPED: '발송됨',
  RECEIVED: '수령 완료',
  CANCELLED: '요청 취소',
  REJECTED: '거절됨',
}

export function textbookRequestBookLabel(request: {
  bookTitle: string | null
  printBookId: number
  volumeLabel: string | null
}) {
  const title = request.bookTitle ?? `#${request.printBookId}`
  return request.volumeLabel ? `${title} (${request.volumeLabel})` : title
}

export function textbookStatusTouchesOutbound(currentStatus: TextbookRequestStatus, targetStatus: TextbookRequestStatus) {
  const outboundStatuses = new Set<TextbookRequestStatus>([
    'OUTBOUND_REQUESTING',
    'OUTBOUND_REQUESTED',
    'OUTBOUND_UNCERTAIN',
    'SHIPPED',
  ])
  return outboundStatuses.has(currentStatus) || outboundStatuses.has(targetStatus)
}
